import React, { useState, useEffect } from "react";
import MainLayout from "../../components/Layouts/Main/MainLayout.index";
import { useNavigate } from "react-router-dom";
import {
  DataIkoLayout,
  DataIkoBody,
  Title,
  StyledCard,
  CardHeader,
  CardBody,
  FormRow,
  Label,
  FormControl,
  ExecuteButton,
  Instructions,
  WarningText,
} from "./DataIko.style";
import { doDataIko } from "../../api/project";
import { toast } from "react-toastify";

export default function DataIko() {
  const navigate = useNavigate();
  const [newUserId, setNewUserId] = useState("");
  const [oldUserId, setOldUserId] = useState("");
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    const userId = sessionStorage.getItem("userId");
    if (!userId) {
      navigate("/");
      return;
    }
  }, [navigate]);

  const handleSubmit = async () => {
    if (!newUserId.trim() || !oldUserId.trim()) {
      toast.error("新X-IDと旧X-IDを入力してください");
      return;
    }
    if (!window.confirm("データ移行を実行しますか？")) return;

    setIsRunning(true);
    try {
      const res = await doDataIko({
        newUserId: newUserId.trim(),
        oldUserId: oldUserId.trim(),
      });
      toast.success(res.msg || "データ移行完了しました");
      setNewUserId("");
      setOldUserId("");
    } catch (error) {
      console.error("データ移行 failed:", error);
      toast.error(error.message || "データ移行に失敗しました");
    } finally {
      setIsRunning(false);
    }
  };

  return (
    <MainLayout>
      <DataIkoLayout>
        <DataIkoBody>
          <Title>データ移行</Title>

          <StyledCard>
            <CardHeader>データ移行設定</CardHeader>
            <CardBody>
              <WarningText>
                ※
                実行前に旧X-IDの内容を確認してください。この操作は取り消せません。
              </WarningText>
              <FormRow>
                <Label>新X-ID(移行先)</Label>
                <FormControl
                  type="text"
                  value={newUserId}
                  onChange={(e) => setNewUserId(e.target.value)}
                  placeholder="移行先の新X-IDを入力してください"
                />
              </FormRow>
              <FormRow>
                <Label>旧X-ID(移行元)</Label>
                <FormControl
                  type="text"
                  value={oldUserId}
                  onChange={(e) => setOldUserId(e.target.value)}
                  placeholder="移行元の旧X-IDを入力してください"
                />
              </FormRow>
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <ExecuteButton onClick={handleSubmit} disabled={isRunning}>
                  {isRunning ? "実行中..." : "実行"}
                </ExecuteButton>
              </div>
            </CardBody>
          </StyledCard>

          <StyledCard>
            <CardHeader>使い方</CardHeader>
            <CardBody>
              <Instructions>
                <li>旧X-IDのデータを新X-IDへ移行する画面です</li>
                <li>
                  移行対象：推しごとカレンダー、雀活マスターのスケジュール・お気に入り・X-IDデータ
                </li>
                <li>
                  「新X-ID」に移行先、 「旧X-ID」に移行元を入力してください
                </li>
                <li>実行結果は画面下部もしくは通知で確認できます</li>
              </Instructions>
            </CardBody>
          </StyledCard>
        </DataIkoBody>
      </DataIkoLayout>
    </MainLayout>
  );
}
